import { ReactNode } from 'react';

import { FormApi } from 'final-form';
import { FormSpy } from 'react-final-form';
import { Location } from 'react-router-dom';
import { RouteLeaveGuard } from 'components/router';

import {
  useRouteLeavingConfirmationDialog,
  LeavePageGuardDialogProps,
} from 'hooks/dialogs';
import { ContentContainer } from 'main-layout/ContentContainer';
import { PageFooter } from 'main-layout/slots';
import { Box, tokens } from '@cast/design-system';

// TODO (Justas): Rename enclosing folder to `form` instead of `form-layouts`

type PageFormFooterProps = {
  children?: ReactNode | ((form: FormApi) => ReactNode);
  leaveRouteDialogProps?: LeavePageGuardDialogProps;
  showRouteGuard?: boolean;
  alwaysShow?: boolean;
  /** If undefined is returned, uses default check (if form is dirty) */
  askBeforeLeaving?:
    | boolean
    | ((props: { nextLocation: Location }) => boolean | undefined);
};

export const PageFormFooter = ({
  children,
  leaveRouteDialogProps,
  showRouteGuard = true,
  alwaysShow = false,
  askBeforeLeaving,
}: PageFormFooterProps) => {
  const leaveGuardConfirmationModal = useRouteLeavingConfirmationDialog(
    leaveRouteDialogProps
  );

  return (
    <FormSpy subscription={{ dirty: true }}>
      {({ dirty, form }) =>
        (dirty || alwaysShow) && (
          <PageFooter>
            <Box
              data-testid="form-footer"
              sx={{
                boxShadow: tokens.theme.shadows.elevation.medium,
                backgroundColor: tokens.theme.bg.structural.surface,
              }}
              py={16}
            >
              <ContentContainer
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={16}
              >
                {typeof children === 'function' ? children(form) : children}
              </ContentContainer>
            </Box>
            {showRouteGuard && (
              <RouteLeaveGuard
                askBeforeLeaving={
                  typeof askBeforeLeaving === 'function'
                    ? (params) => askBeforeLeaving(params) ?? dirty
                    : askBeforeLeaving ?? dirty
                }
                guard={leaveGuardConfirmationModal}
              />
            )}
          </PageFooter>
        )
      }
    </FormSpy>
  );
};
